<template>
  <div class="flex justify-center my-4 w-full">
    <img :src="imageData.url" :alt="imageData.alt" class="h-auto w-full" />
  </div>
</template>

<script>
import { CRITERIA_OPTIONS } from '../../PainelComercial/utils';

export default {
  props: {
    rankingCriteria: {
      type: String,
      required: true,
    },
  },
  computed: {
    imageData() {
      const criteria = CRITERIA_OPTIONS.find(
        (option) => option.type === this.rankingCriteria,
      );

      return {
        url: criteria ? criteria.imageUrl : '',
        alt: criteria ? criteria.altText : 'Imagem não disponível',
      };
    },
  },
};
</script>

<style scoped></style>
